import {
  FETCH_VIDEOS,
  FETCH_VIDEOS_SUCCESS,
  FETCH_VIDEOS_FAIL,
  FETCH_VIDEO_DETAIL,
  FETCH_VIDEO_DETAIL_SUCCESS,
  FETCH_VIDEO_DETAIL_FAIL,
  PLAY_VIDEO,
  PAUSE_VIDEO,
  SET_VIDEO_PROGRESS,
  SET_VIDEO_VOLUME,
} from './constants';

// Fetch Videos/Lectures
export const fetchVideos = (payload) => ({
  type: FETCH_VIDEOS,
  payload,
});

export const fetchVideosSuccess = (payload) => ({
  type: FETCH_VIDEOS_SUCCESS,
  payload,
});

export const fetchVideosFail = (payload) => ({
  type: FETCH_VIDEOS_FAIL,
  payload,
});

// Fetch Video Detail
export const fetchVideoDetail = (payload) => ({
  type: FETCH_VIDEO_DETAIL,
  payload,
});

export const fetchVideoDetailSuccess = (payload) => ({
  type: FETCH_VIDEO_DETAIL_SUCCESS,
  payload,
});

export const fetchVideoDetailFail = (payload) => ({
  type: FETCH_VIDEO_DETAIL_FAIL,
  payload,
});

// Video Player Controls
export const playVideo = (payload) => ({
  type: PLAY_VIDEO,
  payload,
});

export const pauseVideo = () => ({
  type: PAUSE_VIDEO,
});

export const setVideoProgress = (payload) => ({
  type: SET_VIDEO_PROGRESS,
  payload,
});

export const setVideoVolume = (payload) => ({
  type: SET_VIDEO_VOLUME,
  payload,
});
